export const SEARCH_SPOT_LISTS_FAILURE = 'SEARCH_SPOT_LISTS_FAILURE';

export const searchSpotListsFailure = ( payload: Error ) => ({
    type: SEARCH_SPOT_LISTS_FAILURE,
    payload,
    error: true,
});